import { useEffect } from 'react';

// Lightweight per-page SEO helper (no extra dependency).
// Updates document.title and the meta description tag content on mount.
export const useSEO = (title, description) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }
  }, [title, description]);
};
